import api from "./services/mkm.api.js"

const resource = "/formular"

export default {
    senden(formular, payload) {
        return api.post(`${resource}/${formular}`, payload);
    },
    get(identifier) {
        return {
            textbloecke: function () {
                return api.get(`${resource}/${identifier}/textbloecke`);
            },
            textbloeckePowerApps: function () {
                return api.get(`${resource}/powerapps/${identifier}/textbloecke`);
            }
        }
    },
    byhash(hash) {
        return api.get(`${resource}/byhash/${hash}`);
    },
}